import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import { Nav } from 'react-bootstrap'

import { AuthUserContext } from '../../../Authentication/Session'
import * as ROUTES from '../../../../constants/routes'
import * as ROLES from '../../../../constants/roles'

import 'bootstrap/dist/css/bootstrap.min.css'
import navigationStyles from './nav.module.css'

const Navigation = () => (
    <AuthUserContext.Consumer>
        {authUser =>
            authUser ? (
                <Nav className={navigationStyles.nav}>
                    <NavigationAuth authUser={authUser} />
                    <NavigationNonAuth />
                </Nav>
            ) : (
                <Nav className={navigationStyles.nav}>
                    <NavigationNonAuth />
                </Nav>
            )
        }
    </AuthUserContext.Consumer>
)

const NavigationAuth = ({ authUser }) => (
    <Fragment>
        {!!authUser.roles[ROLES.ADMIN] && (
            <>
                <Link to={ROUTES.ADMIN}>
                    <span>Admin</span>
                    <span className="fa fa-chevron-right"></span>
                </Link>
                <Link to={ROUTES.PUBLISH}>
                    {' '}
                    <span>Add Post</span>
                    <span className="fa fa-chevron-right"></span>
                </Link>
            </>
        )}
    </Fragment>
)

const NavigationNonAuth = () => (
    <Fragment>
        <Link to="/news">
            {' '}
            <span>News</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/music">
            {' '}
            <span>Music</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/videos">
            {' '}
            <span>Videos</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/features">
            {' '}
            <span>Features</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/lifestyle">
            {' '}
            <span>Lifestyle</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/publish">
            {' '}
            <span>Add Post</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
        <Link to="/trending">
            {' '}
            <span>Trending:</span>
            <span className="fa fa-chevron-right"></span>
        </Link>
    </Fragment>
)

export default Navigation
